export enum DIAGNOSTIC_STATUS {
  REPAIRED = 'Repaired',
  NOT_REPAIRED = 'NotRepaired',
}
